<template>
  <a-drawer
    :wrapClassName="$store.state.bgLight ? 'lightColor' : ''"
    :title="title"
    :width="1024"
    placement="right"
    :closable="true"
    @close="close"
    :visible="visible"
  >
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">
        <a-row :gutter="24">
          <a-col :md="12" :sm="24">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="运维人员">
              <a-tree-select
                style="width: 100%"
                :dropdownStyle="{ maxHeight: '200px', overflow: 'auto' }"
                :treeData="userTree"
                :disabled="disableSubmit"
                v-decorator="['userId', validatorRules.userId]"
                placeholder="请选择运维人员"
                show-search
                treeNodeFilterProp="title"
              >
                <template slot="title" slot-scope="{ title }">ABC{{ title }}</template>
              </a-tree-select>
            </a-form-item>
          </a-col>
          <a-col :md="12" :sm="24">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="处置公司">
              <a-select
                :allowClear="true"
                optionFilterProp="children"
                :disabled="disableSubmit"
                v-decorator="['companyId', {}]"
                placeholder="请选择处置公司"
                :filterOption="filterOption"
                showSearch
              >
                <a-select-option v-for="(item, key) in companyList" :key="key" :value="item.id">
                  {{ item.name }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="12" :sm="24">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="处置时间">
              <a-date-picker
                style="width: 100%"
                ref="dealDate"
                v-decorator="['dealDate', validatorRules.dealDate]"
                :disabled="disableSubmit"
              />
            </a-form-item>
          </a-col>
          <a-col :md="12" :sm="24">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="处置方式">
              <j-dict-select-tag
                :triggerChange="true"
                :defaultState="true"
                dictCode="waste_liquid_deal_category"
                v-decorator="['category', validatorRules.category]"
                placeholder="请选择处置方式"
                :disabled="disableSubmit"
              >
              </j-dict-select-tag>
            </a-form-item>
          </a-col>
          <a-col :md="12" :sm="24">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="废液总量（L）">
              <a-input placeholder="请输入废液总量（L）" v-model="model.quantity" :disabled="true" />
            </a-form-item>
          </a-col>
          <a-col :md="12" :sm="24">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="处置费用（元）">
              <a-input-number
                style="width: 100%; margin: -5px 0"
                :min="0"
                :step="0.01"
                placeholder="请输入处置费用"
                v-decorator="['fee', {}]"
                :disabled="disableSubmit"
              />
            </a-form-item>
          </a-col>
          <a-col :md="24" :sm="24">
            <a-form-item :labelCol="{ span: 4 }" :wrapperCol="{ span: 20 }" label="备注">
              <a-textarea :rows="2" placeholder="请输入备注" v-decorator="['remark', {}]" :disabled="disableSubmit" />
            </a-form-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="24" :gutter="24">
            <a-tabs>
              <a-tab-pane tab="废液收集">
                <a-row>
                  <a-col :span="24" :gutter="24">
                    <a-table :columns="paramColumns" :dataSource="paramData" :pagination="false" bordered>
                      <template slot="collectDate" slot-scope="text, record, index">
                        <template>{{ text }}</template>
                      </template>

                      <template slot="userId_userName" slot-scope="text, record, index">
                        <template>{{ text }}</template>
                      </template>

                      <template slot="quantity" slot-scope="text, record, index">
                        <template>{{ text }}</template>
                      </template>
                    </a-table>
                  </a-col>
                </a-row>
              </a-tab-pane>
            </a-tabs>
          </a-col>
        </a-row>
        <a-row style="padding-top: 10px">
          <a-col>
            <iws-upload
              ref="iwupload"
              :options="{ btnText: '上传现场照片' }"
              :disableSubmit="disableSubmit"
              accept=".png,.jpg,.svg,.jpeg"
              filesrc="waste_deal"
              :srcid="this.model.id"
            ></iws-upload>
          </a-col>
        </a-row>
        <div class="drawer-msg" v-show="disableSubmit">
          <a-row>
            <a-col :span="12"> 创建信息：{{ model.createBy_userName }} （{{ model.createTime }}） </a-col>
            <a-col :span="12"> 最后修改信息：{{ model.updateBy_userName }} （{{ model.updateTime }}） </a-col>
          </a-row>
        </div>
      </a-form>
    </a-spin>
    <div class="drawer-tool" v-show="!disableSubmit">
      <a-button icon="close" @click="handleCancel">取消</a-button>
      <a-button type="primary" :disabled="!networkStatus" icon="check" @click="handleOk">确定</a-button>
    </div>
  </a-drawer>
</template>

<script>
import { ModalFormMixin } from '@/mixins/ModalFormMixin'
import { getAction, httpAction } from '@/api/manage'
import IwsUpload from '@comp/upload/IwsUpload'
import { queryUserTreeList } from '@/api/api'
import pick from 'lodash.pick'
import moment from 'moment'

const paramColumns = [
  {
    title: '收集开始时间',
    dataIndex: 'stime',
    align: 'center',
    width: '30%',
    scopedSlots: { customRender: 'stime' },
  },
  {
    title: '收集结束时间',
    dataIndex: 'etime',
    align: 'center',
    width: '30%',
    scopedSlots: { customRender: 'etime' },
  },
  {
    title: '运维人员',
    dataIndex: 'userId_userName',
    align: 'center',
    width: '20%',
    scopedSlots: { customRender: 'userId' },
  },
  {
    title: '废液量（L）',
    dataIndex: 'quantity',
    align: 'center',
    width: '20%',
    scopedSlots: { customRender: 'quantity' },
  },
]

const paramData = []
const addParamDataIndex = 0
export default {
  name: 'WasteDealModal',
  components: { IwsUpload },
  mixins: [ModalFormMixin],
  data() {
    this.cacheParamData = paramData.map((item) => ({ ...item }))
    return {
      paramColumns,
      paramData,
      addParamDataIndex,
      userTree: [],
      companyList: [],
      title: '废液处置表单',
      tableName: 'om_waste_deal',
      form_fields: ['siteId', 'userId', 'companyId', 'category', 'quantity', 'fee', 'remark'],
      form_fields_time: ['dealDate'],
      validatorRules: {
        userId: { rules: [{ required: true, message: '请输入运维人员!' }] },
        dealDate: { rules: [{ required: true, message: '请输入处置时间!' }] },
        category: { rules: [{ required: true, message: '请输入处置方式!' }] },
        quantity: { rules: [{ required: true, message: '请输入废液总量（L）!' }] },
      },
    }
  },
  props: ['pagePath'],
  created() {
    this.queryUserTreeList()
    this.loadCompany()
  },
  methods: {
    add(siteId, ids) {
      console.log('record', ids)
      if (undefined == siteId) this.$message.warning('请选择单个站点')
      this.loadCollect(ids)
      this.edit({ siteId })
    },
    edit(record) {
      this.form.resetFields()
      this.model = Object.assign({}, record)
       if (!this.model.userId) this.model.userId = this.$store.getters.userInfo.id
      if (undefined != this.model.id) this.detailCollect(this.model.id)
      if (undefined == this.model.dealDate) this.model.dealDate = new Date().toLocaleDateString()
      this.visible = true
      this.$nextTick(() => {
        var that = this
        that.form.setFieldsValue(pick(that.model, that.form_fields))
        //时间格式化
        let timeVal = {}
        that.form_fields_time.forEach((item, index) => {
          timeVal[item] = that.model[item] ? moment(that.model[item]) : null
        })
        that.form.setFieldsValue(timeVal)
      })
    },
    loadCollect(ids) {
      let collectData = []
      this.paramData = []
      let quantity = 0
      let that = this
      getAction('/om/waste/collect/queryNoDealByIds' + '/' + ids).then((res) => {
        if (res.success) {
          collectData = res.result
          let paramList = []
          for (let i = 0; i < collectData.length; i++) {
            let param = collectData[i]
            param.key = param.id
            param.editable = !that.disableSubmit
            quantity += param.quantity
            paramList.push(param)
          }
          that.model.quantity = quantity
          that.paramData = paramList
        }
      })
    },
    detailCollect(id) {
      let collectData = []
      this.paramData = []
      let that = this
      getAction('/om/waste/collect/queryByDealId' + '/' + id).then((res) => {
        if (res.success) {
          collectData = res.result
          let paramList = []
          for (let i = 0; i < collectData.length; i++) {
            let param = collectData[i]
            param.key = param.id
            param.editable = !that.disableSubmit
            paramList.push(param)
          }
          that.paramData = paramList
        }
      })
    },
    queryUserTreeList() {
      var that = this
      that.userTree = []
      // 用户
      queryUserTreeList().then((res) => {
        if (res.success) {
          for (let i = 0; i < res.result.length; i++) {
            let temp = res.result[i]
            that.userTree.push(temp)
          }
        }
      })
    },
    loadCompany() {
      var that = this
      that.companyList = []
      getAction('/ea/company/info/queryCompanyName').then((res) => {
        if (res.success) {
          that.companyList = res.result
        }
      })
    },
    handleOk() {
      const that = this
      // 触发表单验证
      this.form.validateFields((err, values) => {
        if (!err) {
          that.confirmLoading = true
          let formData = Object.assign(that.model, values)

          //时间格式化
          formData.dealDate = formData.dealDate ? formData.dealDate.format('YYYY-MM-DD') : null
          formData.wasteCollectList = that.paramData
          formData = this.$refs.iwupload.getUploadListToFromData(formData)
          let httpurl = '',
            method = ''
          if (!this.model.id) {
            httpurl = this.url.add ? this.url.add : this.pagePath
            method = 'post'
          } else {
            httpurl = this.url.edit ? this.url.edit : this.pagePath
            method = 'put'
          }
          httpAction(httpurl, formData, method)
            .then((res) => {
              if (res.success) {
                this.$refs.iwupload.resetUploadFiles()
                that.$notification.success({ message: res.message })
                that.$emit('ok')
                that.close()
              } else {
                this.$notification.warning({ message: res.message })
              }
            })
            .finally(() => {
              that.confirmLoading = false
            })
        }
      })
    },
    filterOption(input, option) {
      console.log('option', option.componentOptions.children[0].text)
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
  },
}
</script>

<style scoped>
@import '~@assets/less/common.less';
</style>